export enum EInputType {
    TEXT = "text",
    NUMBER = "number",
    FONT_SELECT = "font-select",
    COLOR_PICKER = "color-picker",
}
